import dayjs from 'dayjs';
import type { SvpAsset } from '@vgtv/api-client/lib/svp_asset';

import { formatDate } from './date';

export function groupAssetsByDate<T extends SvpAsset>(assets: T[]) {
  return Object.entries(
    assets.reduce<Record<string, T[]>>((acc, asset) => {
      const formattedDate = formatDate(asset.flightTimes?.start! * 1000);
      if (acc[formattedDate]) {
        acc[formattedDate].push(asset);
      } else {
        acc[formattedDate] = [asset];
      }

      return acc;
    }, {})
  ).sort((a, b) => (dayjs(a[0]).isAfter(b[0]) ? 1 : -1));
}
